import React from 'react';
import { GitCompareArrows, X } from 'lucide-react';

export const CompareBar = ({ selected, onRemove, onCompare, onClear }) => {
  if (selected.length === 0) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#111]/95 backdrop-blur-md border-t border-[#e8ff00]/30" data-testid="compare-bar">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <GitCompareArrows className="w-4 h-4 text-[#e8ff00] flex-shrink-0" />
          <div className="flex gap-2 overflow-x-auto scrollbar-hide">
            {selected.map((g) => (
              <span key={g.name} className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-zinc-800 border border-zinc-700 text-white text-xs font-heading whitespace-nowrap flex-shrink-0">
                {g.name}
                <button onClick={() => onRemove(g)} className="text-zinc-500 hover:text-red-400 transition-colors">
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))}
          </div>
          <span className="text-zinc-500 text-xs flex-shrink-0">{selected.length}/3</span>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button onClick={onClear} className="px-3 py-2 text-zinc-500 text-xs font-heading uppercase tracking-wider hover:text-white transition-colors" data-testid="compare-clear-btn">
            Clear
          </button>
          <button
            onClick={onCompare}
            disabled={selected.length < 2}
            className={`px-5 py-2 text-xs font-heading uppercase tracking-wider transition-all ${
              selected.length >= 2 ? 'bg-[#e8ff00] text-black hover:opacity-90' : 'bg-zinc-800 text-zinc-600 cursor-not-allowed'
            }`}
            data-testid="compare-now-btn"
          >
            Compare Now
          </button>
        </div>
      </div>
    </div>
  );
};
